// Shared referral-partner / outreach category taxonomy + badge colors.
export const PARTNER_CATEGORIES = [
  "Building Manager",
  "Doctor's Office",
  "Community Resource",
  "Hospital/Discharge",
  "Case Manager",
  "Government/Housing",
  "Nonprofit",
  "Community Org",
  "Healthcare",
  "Event/Festival",
  "Word-of-mouth",
  "Other",
];

export const CAT_COLOR = {
  "Building Manager": "bg-[#1E73C9]/10 text-[#1E73C9]",
  "Doctor's Office": "bg-[#7e22ce]/10 text-[#7e22ce]",
  "Community Resource": "bg-[#2E7D32]/10 text-[#2E7D32]",
  "Hospital/Discharge": "bg-[#b91c1c]/10 text-[#b91c1c]",
  "Case Manager": "bg-[#b8860b]/10 text-[#b8860b]",
  "Government/Housing": "bg-[#15233B]/10 text-[#15233B]",
  "Nonprofit": "bg-[#0e7490]/10 text-[#0e7490]",
  "Community Org": "bg-[#2E7D32]/10 text-[#2E7D32]",
  "Healthcare": "bg-[#7e22ce]/10 text-[#7e22ce]",
  "Event/Festival": "bg-[#FFCB05]/20 text-[#7a5a1a]",
  "Word-of-mouth": "bg-[#1E73C9]/10 text-[#1E73C9]",
  "Other": "bg-[#15233B]/10 text-[#15233B]/70",
};

export const catColor = (c) => CAT_COLOR[c] || CAT_COLOR.Other;
